import { DossierType } from './types'
import { SAVE_DOSSIER } from './actionTypes'
import { DossierModel } from '../../../types/dossier/dossierModel'

const initialState = null

const dossier = (
	state: DossierModel | null = initialState,
	action: DossierType
): DossierModel | null => {
	switch (action.type) {
		case SAVE_DOSSIER: {
			return 'payload' in action ? action.payload : initialState
		}
		default:
			return state
	}
}

export default dossier
